/**
 * 常量
 * 
*/

//登录
export const LOGIN_DATA = 'login/LOGIN_DATA';

//图片验证码
export const PICTRUE_CODE = 'login/PICTRUE_CODE';

